import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

export type Role = {
    global_role_id: number;
    name: "pencil_writer" | "critic" | "producer";
    label: string;
    approved: number;
};

type UserInfo = {
    date_of_birth: Date;
    gender: string;
    genre: string;
    intent: "writer" | "critic" | "producer" | "platform";
    name: string;
    profile_image: string | null;
    roles: Role[];
};

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export function getInfo(): UserInfo | null {
    const infoString = Cookies.get("info");
    if (infoString === undefined) return null;
    const userInfo: UserInfo = JSON.parse(infoString);
    return {
        ...userInfo,
        roles: userInfo.roles.filter(
            (role) =>
                role.name.match(/^(pencil_writer|critic|producer)$/) !== null &&
                role.name !== userInfo.intent
        ),
        date_of_birth: new Date(userInfo.date_of_birth),
    };
}
